<app-modal-basic #modalRelatorio (closed)="destroyComponent()">
  <div class="app-modal-header">
    <h4 class="modal-title">Saldo de Contas</h4>
  </div>
  <div class="app-modal-body">
    <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div class="form-group col-sm-12">
          <label>Exibir saldo no dia:</label>
          <app-data formControlName="dataReferencia"></app-data>
          <show-errors [control]="impressaoForm.controls.dataReferencia"></show-errors>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-12">
          <div class="checkbox-fade fade-in-default">
            <label>
              <input type="checkbox" formControlName="desconsiderarLancamentosTerceiros">
              <span class="cr">
                <i class="cr-icon icofont icofont-ui-check txt-default"></i>
              </span> <span>Desconsiderar lançamentos de terceiros</span>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12">
          <div class="checkbox-fade fade-in-default">
            <label>
              <input type="checkbox" formControlName="desconsiderarFluxoDeCaixa">
              <span class="cr">
                <i class="cr-icon icofont icofont-ui-check txt-default"></i>
              </span> <span>Desconsiderar contas correntes que não entrem em fluxo de caixa</span>
            </label>
          </div>
        </div>
      </div>

      <button type="submit" (click)="validaForm()" class="btn btn-primary ripple light">
        <i class="icofont icofont-refresh"> </i> OK
      </button>
      <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-close"></i>
        Cancelar
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
  </div>

</app-modal-basic>